import { useEffect, useState } from 'react'

import { HotelPricingRates } from '@monorepo/functions/src/types/config'

import { loadPeriodsForDateRange } from '@/shared/utils/pricing-periods'
import { usePricingPeriodsOptional } from '@/shared/providers/PricingPeriodProvider'

export function usePeriodsForReservation(checkIn?: string, checkOut?: string) {
    const provider = usePricingPeriodsOptional()
    const [periods, setPeriods] = useState<HotelPricingRates[]>(provider?.periods ?? [])
    const [loading, setLoading] = useState(Boolean(checkIn && checkOut))

    useEffect(() => {
        if (!checkIn || !checkOut) {
            setPeriods(provider?.periods ?? [])
            setLoading(false)
            return
        }

        let cancelled = false
        setLoading(true)

        loadPeriodsForDateRange(checkIn, checkOut)
            .then(loadedPeriods => {
                if (!cancelled) {
                    setPeriods(loadedPeriods)
                }
            })
            .catch(error => {
                console.error('Error loading periods for reservation:', error)
                if (!cancelled) {
                    setPeriods(provider?.periods ?? [])
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false)
                }
            })

        return () => {
            cancelled = true
        }
    }, [checkIn, checkOut, provider?.periods])

    return { periods, loading }
}
